import type { RouterConfig } from "@nuxt/schema"
import qs from "qs"
import Logger from "@/utils/Logger"
import { normalizeMalformedQuery } from "@/utils/normalizeMalformedQuery"
import { stripTrailingSlashes } from "@/utils/stripTrailingSlashes"

export default <RouterConfig>{
  routes: (_routes) => {
    const { ssrContext } = useNuxtApp()
    const customPath = useCustomPath()

    // Get the path of the JobShop from the event context, prefilled by the custom-path server middleware
    if (ssrContext?.event.context.customPath)
      customPath.value = ssrContext?.event.context.customPath

    const prefix = stripTrailingSlashes(customPath.value || "")
    if (prefix) {
      if (process.server)
        Logger().log(`Prepending ${prefix} to all existing routes`)

      return _routes.map(route => ({
        ...route,
        path: prefix + route.path,
      }))
    }
  },
  // qs handles deeply nested typesense queries; normalizeMalformedQuery recovers UTM params
  // when an upstream redirect concatenates them onto a target that already contains `?`.
  parseQuery: q => qs.parse(normalizeMalformedQuery(q)),
  stringifyQuery: query => qs.stringify(query, {
    addQueryPrefix: false,
    arrayFormat: "repeat",
    format: "RFC3986",
  }),
}
